import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";

export const exportPayrollShuttle = async (
    year: number,
    month: number,
    token: string,
    dispatch: Function
) => {
    try {
        const response = await fetch(`${urlAPI}/payroll-shuttle/${year}/${month}/export`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
            throw new Error("Export impossible");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `navette_paie_${year}_${month}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error(error);
        dispatch(showSnackbar("Erreur lors de l'export de la navette de paie.", "error"));
    }
};
